(function () {
  'use strict';

  var ADS_ID = 'AW-18200522048';
  var GENERAL_SEND_TO = 'AW-18200522048/8DJaCPK4lOIcEMDa1-ZD';
  var CABINET_SEND_TO = 'AW-18200522048/GT47CJnroJEdEMDa1-ZD';
  var PENDING_KEY = 'ig_contact_form_pending';
  var DISPATCHED_KEY = 'ig_contact_form_dispatched';
  var MAX_AGE_MS = 30 * 60 * 1000;
  var MAX_FUTURE_SKEW_MS = 30 * 1000;

  function analyticsAllowedForDiagnostics() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true;
    } catch (e) { return false; }
  }

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function storageGet(key) {
    try { return window.sessionStorage && window.sessionStorage.getItem(key); }
    catch (e) { return null; }
  }

  function storageSet(key, value) {
    try {
      if (!window.sessionStorage) return false;
      window.sessionStorage.setItem(key, value);
      return window.sessionStorage.getItem(key) === value;
    } catch (e) {
      return false;
    }
  }

  function parseJson(value) {
    if (!value) return null;
    try { return JSON.parse(value); }
    catch (e) { return null; }
  }

  function eventId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'ig-' + now() + '-' + Math.random().toString(36).slice(2);
  }

  function normalizeText(value) {
    return String(value || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 80);
  }

  function consentAllowsTracking() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== 'function' || typeof privacy.analyticsProcessingAllowed !== 'function') {
      return false;
    }
    try {
      return privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true;
    } catch (e) {
      return false;
    }
  }

  function trackedFormFromEvent(event) {
    var target = event && event.target;
    if (!target) return null;
    if (target.matches && target.matches('form[data-ig-lead-form]')) return target;
    if (target.closest) return target.closest('form[data-ig-lead-form]');
    return null;
  }

  function fieldNameImpliesInterest(fieldName) {
    var name = String(fieldName || '').toLowerCase();
    return /interest|interested/.test(name);
  }

  function valueImpliesCabinet(value) {
    return /cabinet|armoire|fusion\s*plus|fusionplus|\blux\b/.test(String(value || '').toLowerCase());
  }

  function classifyCabinetInterest(form) {
    if (!form || typeof form.querySelectorAll !== 'function') return false;
    var fields = form.querySelectorAll('input[name], textarea[name], select[name]');
    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (fieldNameImpliesInterest(field.getAttribute('name')) && valueImpliesCabinet(field.value)) return true;
    }
    return false;
  }

  function normalizedLeadType(form, rawLeadType, productHandle) {
    if (rawLeadType === 'cabinet_help') return 'cabinet_help';
    if (productHandle || classifyCabinetInterest(form)) return 'cabinet_consultation';
    return rawLeadType || 'consultation';
  }

  function isCabinetLead(leadType) {
    return leadType === 'cabinet_help' || leadType === 'cabinet_consultation';
  }

  function rememberPendingSubmit(event) {
    var form = trackedFormFromEvent(event);
    if (!form || event.defaultPrevented) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

    var formId = form.getAttribute('data-ig-form-id') || form.getAttribute('id') || '';
    var rawLeadType = normalizeText(form.getAttribute('data-ig-lead-form'));
    var productHandle = normalizeText(form.getAttribute('data-ig-product-handle'));
    if (!formId || !rawLeadType) return;

    var leadType = normalizedLeadType(form, rawLeadType, productHandle);
    var cabinetConsultation = isCabinetLead(leadType);
    storageSet(PENDING_KEY, JSON.stringify({
      eventId: eventId(),
      analyticsAllowedAtSubmit: analyticsAllowedForDiagnostics(),
      formId: formId,
      leadType: leadType,
      cabinetConsultation: cabinetConsultation,
      productHandle: productHandle,
      timestamp: now(),
    }));
  }

  function currentHashId() {
    return String((window.location && window.location.hash) || '').replace(/^#/, '');
  }

  function validPendingFor(marker) {
    var formId = marker.getAttribute('data-ig-form-id') || '';
    if (!formId || currentHashId() !== formId) return null;

    var pending = parseJson(storageGet(PENDING_KEY));
    if (!pending || pending.formId !== formId || !pending.eventId) return null;
    var age = now() - Number(pending.timestamp || 0);
    if (age > MAX_AGE_MS || age < -MAX_FUTURE_SKEW_MS) return null;

    var dispatched = parseJson(storageGet(DISPATCHED_KEY));
    if (dispatched && dispatched.eventId === pending.eventId) return null;

    var leadType = normalizeText(pending.leadType || marker.getAttribute('data-ig-lead-type'));
    var productHandle = normalizeText(pending.productHandle || marker.getAttribute('data-ig-product-handle'));
    return {
      eventId: normalizeText(pending.eventId),
      analyticsAllowedAtSubmit: pending.analyticsAllowedAtSubmit === true,
      formId: formId,
      leadType: leadType,
      cabinetConsultation: pending.cabinetConsultation === true || isCabinetLead(leadType),
      productHandle: productHandle,
    };
  }

  function ensureGtag() {
    if (typeof window.gtag === 'function') return window.gtag;

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', ADS_ID, {send_page_view: false});

    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(ADS_ID);
    document.head.appendChild(script);
    return window.gtag;
  }

  function publishShopifyEvent(payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('ig_contact_form_success', payload);
      }
    } catch (e) {}
  }

  function markDispatchAttempt(payload) {
    return storageSet(DISPATCHED_KEY, JSON.stringify({
      eventId: payload.eventId,
      formId: payload.formId,
      leadType: payload.leadType,
      cabinetConsultation: payload.cabinetConsultation === true,
      productHandle: payload.productHandle,
      timestamp: now(),
    }));
  }

  function sendToFor(payload) {
    return payload.cabinetConsultation === true || isCabinetLead(payload.leadType) ? CABINET_SEND_TO : GENERAL_SEND_TO;
  }

  function dispatchConversion(payload) {
    if (!consentAllowsTracking()) return false;
    if (!markDispatchAttempt(payload)) return false;

    try {
      var gtag = ensureGtag();
      gtag('event', 'conversion', {
        send_to: sendToFor(payload),
        value: 0,
        currency: 'CAD',
        transaction_id: payload.eventId,
        lead_type: payload.leadType,
        cabinet_consultation: payload.cabinetConsultation === true,
        product_handle: payload.productHandle,
      });
      publishShopifyEvent({
        event_id: payload.eventId,
        form_id: payload.formId,
        lead_type: payload.leadType,
        cabinet_consultation: payload.cabinetConsultation === true,
        product_handle: payload.productHandle,
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  function processSuccessMarkers() {
    var markers = document.querySelectorAll('[data-ig-contact-form-success]');
    for (var i = 0; i < markers.length; i += 1) {
      var payload = validPendingFor(markers[i]);
      if (payload) {
        // Validated Shopify success + pending nonce only; never emit on a submit attempt.
        try { if (typeof window.CustomEvent === 'function' && typeof document.dispatchEvent === 'function') {
          document.dispatchEvent(new window.CustomEvent('ig:contact-success', {detail: {
            event_id: payload.eventId,
            lead_type: payload.leadType,
            analytics_allowed_at_submit: payload.analyticsAllowedAtSubmit === true,
          }}));
        } } catch (e) {}
        dispatchConversion(payload);
      }
    }
  }

  document.addEventListener('submit', rememberPendingSubmit, false);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processSuccessMarkers, false);
  } else {
    processSuccessMarkers();
  }

  if (window.__IG_TRACKING_TEST__) {
    window.__igContactFormTrackingTest = {
      classifyCabinetInterest: classifyCabinetInterest,
      consentAllowsTracking: consentAllowsTracking,
      validPendingFor: validPendingFor,
      rememberPendingSubmit: rememberPendingSubmit,
      processSuccessMarkers: processSuccessMarkers,
    };
  }
}());
